import React from 'react';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import classNames from 'classnames';
import { H1, H2, NamedLink } from '../../../components';
import { lazyLoadWithDimensions } from '../../../util/uiHelpers';

import heroImage from './images/hero-image.png';

import css from './SectionHero.module.css';

const Image = props => {
  const { alt, ...rest } = props;

  return <img {...rest} alt={alt} />;
};

const LazyImage = lazyLoadWithDimensions(Image, {
  loadAfterInitialRendering: 3000,
});

const SectionHero = props => {
  const { className } = props;

  const intl = useIntl();

  const classes = classNames(css.root, className);

  const cta = (
    <NamedLink name="ArtistSignupPage" className={css.primaryCta}>
      {intl.formatMessage({ id: 'General.signUpHere' })}
    </NamedLink>
  );

  return (
    <div className={classes}>
      <div className={css.content}>
        <div className={css.text}>
          <H1 className={css.title}>
            <FormattedMessage id="ArtistHelpPage.heroTitle" />
          </H1>

          <H2 className={css.desc}>{intl.formatMessage({ id: 'ArtistHelpPage.heroDesc' })}</H2>

          <div className={css.desktopCtas}>{cta}</div>
        </div>

        <div className={css.images}>
          <LazyImage src={heroImage} alt="" />
        </div>

        <div className={css.mobileCtas}>{cta}</div>
      </div>
      <div className={css.gradient} />
    </div>
  );
};

export default SectionHero;
